import { render, staticRenderFns } from "./ElementCard.vue?vue&type=template&id=a4d1388e&scoped=true&"
import script from "./ElementCard.vue?vue&type=script&lang=ts&"
export * from "./ElementCard.vue?vue&type=script&lang=ts&"
import style0 from "./ElementCard.vue?vue&type=style&index=0&id=a4d1388e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d1388e",
  null
  
)

export default component.exports